export default __webpack_public_path__ + "static/media/logo_words.16612c0e.png";